import React, { Component } from "react";
import { Pie } from "react-chartjs-2";

import { connect } from "react-redux";
import { openModal } from "../../../../store/actions/ModalActions";

import * as d3 from "d3";

import { branch_category_chart_data } from "../../../../constants/chart_definitions";
import { AspectRatio, Search } from "@material-ui/icons";
import BranchCategoryViewFilter from "../../view_filters/BranchCategory/BranchCategoryViewFilter";

import { GetBranchCategoryOverallV4 } from "../../../../store/actions/reports-v4/branch_category_service_actions";
import { interpolateColors } from "../../../../helpers/colorGenerator";
import NoChartData from "../../../../components/extensions/ErrorPageDefaults/NoChartData";
import { DashboardContext } from "../../dashboard_context";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { Toolbar, IconButton } from "@material-ui/core";
import PieChartLoader from "../../../../components/extensions/PieChartLoader";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import moment from "moment";
import { SetChartBranchCategoryTitle } from "../../../../store/actions/reports/chart_title_actions";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());
const branch_category_filter = {
  from: fromDate,
  to: toDate,
};

const renderPolar = (data, title, disableAspectRatio = true) => {
  return (
    <Pie
      height={250}
      options={{
        responsive: true,
        title: {
          display: false,
          text: title,
          fontsize: 20,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 20,
          },
        },
        legend: {
          display: true,
          position: "left",
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                let dataset = tooltipItem.dataset;
                let currentValue = dataset.data[tooltipItem.dataIndex];
                let total = dataset.data.reduce((a, b) => a + b, 0);
                let percentage = ((currentValue / total) * 100).toFixed(2);
                return ` ${percentage}%`;
              },
            },
          },
          datalabels: {
            display: true,
            color: "black",
            anchor: "end",
            align: "center",
            offset: -100,
            label: function (tooltipItem) {
              let dataset = tooltipItem.dataset;
              let currentValue = dataset.data[tooltipItem.dataIndex];
              let total = dataset.data.reduce((a, b) => a + b, 0);
              let percentage = ((currentValue / total) * 100).toFixed(2);
              return ` ${percentage}%`;
            },
          },
          outlabels: false,
        },
      }}
      data={branch_category_chart_data(data)}
    />
  );
};

class BranchCategoryView extends Component {
  state = {
    isLoading: false,
    dataSet: {
      items: [],
      labels: [],
      colors: [],
    },
    dates: branch_category_filter,
    toView: "piece",
    clusterId: null,
    areaId: null,
    areaSelectContext: null,
    clusterSelectContext: null,
  };

  componentDidMount() {
    this.PremiseGetOverallBranchCategory({
      covered_date: this.state.date,
      isRange: false,
    }).then((resp) => {
      this.setState({
        isLoading: true,
      });

      var chartTitle = renderChartTitle(
        moduleNames.branchCategory,
        OperationScope.overall,
        moment(this.state.date).format("MMMM DD YYYY")
      );

      this.props.SetChartBranchCategoryTitle(chartTitle);

      this.appendChartData();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.branch_category_list !== this.props.branch_category_list) {
      this.setState({
        isLoading: true,
      });

      this.appendChartData();
    }
  }

  appendChartData = () => {
    let { branch_category_list } = this.props;
    var colorScale = d3.interpolate("#ff3838", "#7d5fff");

    let temp_branch_category = [];
    if (branch_category_list) {
      temp_branch_category = branch_category_list;
    }

    let data = temp_branch_category.map((item) => {
      return {
        name: item.categoryName,
        value:
          this.state.toView === "piece"
            ? item.totalPieces
            : item.totalPrincipal,
      };
    });
    const totalValue = data.reduce((sum, item) => sum + item.value, 0);

    var tempDataset = {
      ...this.state.dataSet,
      items: data.map((item) => item.value),
      labels: data.map((item) => {
        const percentage = ((item.value / totalValue) * 100).toFixed(2);
        return `${item.name} (${percentage}%)`;
      }),
      colors: interpolateColors(data.length, colorScale, {
        colorStart: 0,
        colorEnd: 1,
        useEndAsStart: true,
      }),
    };

    this.setState({ dataSet: tempDataset }, () => {
      this.setState({
        isLoading: false,
      });
    });
  };

  handleRadioChanged = (e) => {
    this.setState(
      {
        toView: e,
        clusterId: null,
        areaId: null,
        areaSelectContext: null,
        clusterSelectContext: null,
      },
      () => {
        this.appendChartData();
      }
    );
  };

  renderChart = () => {
    let { branch_category_list } = this.props;

    return this.state.isLoading ? (
      <PieChartLoader />
    ) : (
      <div>
        {branch_category_list.length === 0 ? (
          <NoChartData />
        ) : (
          <>
            <strong>{this.props.chartTitle}</strong>
            {renderPolar(this.state.dataSet, this.props.chartTitle)}
          </>
        )}
        {this.renderOptions()}
      </div>
    );
  };

  renderOptions = () => {
    let { branch_category_list } = this.props;

    return (
      <Toolbar className="float-right">
        <ToggleButtonGroup
          hidden={branch_category_list.length === 0}
          onChange={this.handleRadioChanged}
          size="sm"
          name="filterByRadio"
          type="radio"
          value={this.state.toView}
        >
          <ToggleButton size="sm" variant="light" value="piece">
            Piece
          </ToggleButton>
          <ToggleButton size="sm" variant="light" value="principal">
            Principal
          </ToggleButton>
        </ToggleButtonGroup>
        <IconButton
          onClick={() => {
            this.props.openModal({
              size: "lg",
              custom: false,
              title: "Filter Branch Category",
              currentComponent: (
                <BranchCategoryViewFilter Refresh={this.appendChartData} />
              ),
            });
          }}
        >
          <Search />
        </IconButton>
        <IconButton
          hidden={branch_category_list.length === 0}
          onClick={() => {
            this.props.openModal({
              size: "lg",
              custom: true,
              title: "Branch Category",
              currentComponent: (
                <>
                  <strong>{this.props.chartTitle}</strong>
                  <Pie
                    height={100}
                    options={{
                      responsive: true,
                      title: {
                        display: false,
                        text: this.props.chartTitle,
                        fontsize: 20,
                      },
                      layout: {
                        padding: {
                          left: 60,
                          right: 20,
                          top: 10,
                          bottom: 10,
                        },
                      },
                      legend: {
                        display: true,
                        position: "left",
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          color: "#212121",
                          formatter: function (value, context) {
                            let dataset = context.dataset.data;
                            let total = dataset.reduce((a, b) => a + b, 0);
                            let percentage = ((value / total) * 100).toFixed(2);
                            return `${percentage}%`;
                          },
                        },
                        outlabels: false,
                      },
                    }}
                    data={branch_category_chart_data(this.state.dataSet)}
                  />
                </>
              ),
            });
          }}
        >
          <AspectRatio />
        </IconButton>
        <ModuleLocked
          Lock={() => this.context.Lock(moduleNames.branchCategory)}
          Unlock={() => this.context.Unlock(moduleNames.branchCategory)}
          isLocked={this.context.branchCategoryLocked}
        />
      </Toolbar>
    );
  };

  render() {
    return this.state.isLoading ? (
      <PieChartLoader />
    ) : (
      <>{this.renderChart()}</>
    );
  }

  PremiseGetOverallBranchCategory = async (data) => {
    this.setState({
      isLoading: true,
    });

    return await this.props.GetBranchCategoryOverallV4(data);
  };
}

const mapStateToProps = (state) => {
  return {
    chartTitle: state.chart_title.branchCategory,
    branch_category_list: state.branch_category.branch_category_list,
  };
};

const mapDispatchToProps = {
  openModal: openModal,
  SetChartBranchCategoryTitle: SetChartBranchCategoryTitle,
  GetBranchCategoryOverallV4: GetBranchCategoryOverallV4,
};

BranchCategoryView.contextType = DashboardContext;
export default connect(mapStateToProps, mapDispatchToProps)(BranchCategoryView);
